export default __webpack_public_path__ + "static/media/x.0be19366.svg";